import { StatsElementData } from '../interfaces/StatsElementData';

export const initialStatsElementData: StatsElementData = {
  highCharts: [],
  grids: [],
  info: null,
};
